// @ts-nocheck
import React from 'react';
import ElementView from './base/element-view';
import Button from '../../shared/button';

export default class YesNoElementView extends ElementView {
  renderEditable() {
    const { styles } = YesNoElementView;

    return (
      <div className={css(styles.container)}>
        <Button
          affirmOutlined
          first
          disabled={this.props.disabled}
          onClick={this.handlePositiveClick}
          className={css(styles.button, this.isPositive && styles.pressed)}
          defaultMargin={false}
        >
          {this.props.element.positiveChoice.label}
        </Button>
        <Button
          affirmOutlined
          middle={this.props.element.neutralEnabled}
          last={!this.props.element.neutralEnabled}
          disabled={this.props.disabled}
          onClick={this.handleNegativeClick}
          className={css(styles.button, this.isNegative && styles.pressed)}
          defaultMargin={false}
        >
          {this.props.element.negativeChoice.label}
        </Button>
        {this.renderNeutralButton()}
      </div>
    );
  }

  get isPositive() {
    return this.props.value.isPositive;
  }

  get isNegative() {
    return this.props.value.isNegative;
  }

  get isNeutral() {
    return this.props.value.isNeutral;
  }

  renderNeutralButton() {
    const { styles } = YesNoElementView;

    if (!this.props.element.neutralEnabled) {
      return null;
    }

    return (
      <Button
        affirmOutlined
        last
        onClick={this.handleNeutralClick}
        disabled={this.props.disabled}
        className={css(styles.button, this.isNeutral && styles.pressed)}
        defaultMargin={false}
      >
        {this.props.element.neutralChoice.label}
      </Button>
    );
  }

  handlePositiveClick = (value) => {
    if (this.props.disabled) {
      return;
    }

    if (this.props.value.isPositive) {
      this.props.value.textValue = null;
    } else {
      this.props.value.textValue = this.props.element.positiveChoice.value;
    }

    this.props.onChange(this.props.value);
  };

  handleNegativeClick = (value) => {
    if (this.props.disabled) {
      return;
    }

    if (this.props.value.isNegative) {
      this.props.value.textValue = null;
    } else {
      this.props.value.textValue = this.props.element.negativeChoice.value;
    }

    this.props.onChange(this.props.value);
  };

  handleNeutralClick = (value) => {
    if (this.props.disabled) {
      return;
    }

    if (this.props.value.isNeutral) {
      this.props.value.textValue = null;
    } else {
      this.props.value.textValue = this.props.element.neutralChoice.value;
    }

    this.props.onChange(this.props.value);
  };
}

const styles = cssInJS({
  container: {
    marginTop: 4,
    marginBottom: 4,
  },

  button: {
    minWidth: 100,
    textAlign: 'center',
    verticalAlign: 'middle',
    display: 'inline-block',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    textDecoration: 'none',
    WebkitAppearance: 'none',
    fontWeight: 900,
    fontFamily: 'Lato, sans-serif',
    userSelect: 'none',
    padding: '0.35rem 0.9rem',
    fontSize: '11px',
    lineHeight: 1.5,
    marginTop: '.25rem',
    marginBottom: '.25rem',
    textTransform: 'uppercase',
  },

  pressed: {
    backgroundColor: '#4baef8 !important',
    border: '1px solid #4baef8 !important',
    color: '#fff !important',
  },
});

YesNoElementView.styles = styles;
